<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>设备</el-breadcrumb-item>
      <el-breadcrumb-item>应用与工艺管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="应用名称">
            <el-input
              v-model="filter.name"
              placeholder="应用名称"
              @keyup.enter.native="requestSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header" v-permission="Auth.deviceCraftManage">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleEdit"
          >新增设备应用</el-button
        >
      </div>
      <el-table :data="list" v-loading="loading" stripe style="width: 100%">
        <el-table-column align="left" label="应用名称" prop="application">
          <template slot-scope="scope">
            {{ scope.row.application.join(' / ') }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="包含工艺" prop="crafts">
          <template slot-scope="scope">
            <el-tag
              size="small"
              class="mr-5"
              v-for="item in scope.row.crafts"
              :key="item"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.deviceCraftManage"
              title="确认删除该应用吗？"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              v-permission="Auth.deviceCraftManage"
              class="ml-5"
              type="primary"
              plain
              size="mini"
              v-if="scope.row.parent_id === 0"
              @click="handleEdit(scope.$index, scope.row, true)"
              >添加子类</el-button
            >
            <el-button
              v-permission="Auth.deviceCraftManage"
              class="ml-5"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <ModelFormer
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></ModelFormer>
  </div>
</template>

<script>
import { deviceCraftList, deleteDeviceCraft } from '@/service/getData'
import ModelFormer from './former'

export default {
  components: {
    ModelFormer,
  },
  data() {
    return {
      loading: false,
      model: {},
      itemFormerVisible: false,
      editIndex: 0,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        name: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await deviceCraftList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.name = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.getData()
      // this.list.unshift(data)
    },
    updatedCallback(data) {
      this.getData()
      // this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item, addChild = false) {
      if (item && !addChild) {
        this.editIndex = index
        this.model = this.clone(item)
      } else {
        this.model = {
          name: '',
          parent_id: addChild ? item.id : 0,
          crafts: [],
        }
      }
      this.itemFormerVisible = true
    },
    async handleDelete(index, id) {
      let res = await deleteDeviceCraft(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>
